export default __webpack_public_path__ + "static/media/1786.70a884f1.png";